import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '@/views/Home.vue';
import PrivacyView from '@/views/redirects/documentation/PrivacyView.vue';
import TermsView from '@/views/redirects/documentation/TermsView.vue';
import HelpView from '@/views/redirects/documentation/HelpView.vue';
import ZoomView from '@/views/redirects/documentation/ZoomView.vue';
import EventsView from '@/views/redirects/events/EventsView.vue';
import EventView from '@/views/redirects/events/EventView.vue';
import EventInfoView from '@/views/redirects/events/EventInfoView.vue';
import EventLearnerView from '@/views/redirects/events/EventLearnerView.vue';
import ProgrammeView from '@/views/redirects/programmes/ProgrammeView.vue';
import ProgrammeInfoView from '@/views/redirects/programmes/ProgrammeInfoView.vue';
import SubscriptionView from '@/views/redirects/settings/SubscriptionView.vue';
import TrainersView from '@/views/redirects/trainers/TrainersView.vue';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  // Redirect emailed/notification links from GP1 to corresponding GP2 routes
  { path: '/event', component: EventsView },
  { path: '/event/details/:eventId', component: EventView, props: true },
  { path: '/event/info/:eventId', component: EventInfoView, props: true },
  { path: '/event/:eventId/learner/:learnerId', component: EventLearnerView, props: true },
  { path: '/programme/details/:programmeId', component: ProgrammeView, props: true },
  { path: '/programme/info/:programmeId', component: ProgrammeInfoView, props: true },
  { path: '/settings/subscription/details', component: SubscriptionView },
  { path: '/trainer', component: TrainersView },
  // // Redirect Zoom App Marketplace Oauth app links
  { path: '/documentation/privacy', component: PrivacyView },
  { path: '/documentation/terms', component: TermsView },
  { path: '/documentation/help', component: HelpView },
  { path: '/documentation/zoom', component: ZoomView },
  // GP2 routes
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/pricing',
    name: 'Pricing',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Pricing.vue'),
  },
  {
    path: '/faq',
    name: 'FAQ',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/FAQ.vue'),
  },
  {
    path: '/signin',
    name: 'SignIn',
    beforeEnter() { location.href = `${process.env.VUE_APP_WEBAPP_BASE_URL}/signin`; },
  },
  {
    path: '/signup',
    name: 'SignUp',
    beforeEnter() { location.href = `${process.env.VUE_APP_WEBAPP_BASE_URL}/signup`; },
  },
  {
    path: '*',
    name: 'NotFound',
    redirect: { name: 'Home' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
